const MIN_LENGTH = 8
const GENERATED_LENGTH = 16

const LOWERCASE = "abcdefghijklmnopqrstuvwxyz"
const UPPERCASE = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
const DIGITS = "0123456789"
const SYMBOLS = "!@#$%^&*()-_=+[]{}|;:,.<>?"
const ALL_CHARS = LOWERCASE + UPPERCASE + DIGITS + SYMBOLS

export function generatePassword() {
  const chars = [
    LOWERCASE[Math.floor(Math.random() * LOWERCASE.length)],
    UPPERCASE[Math.floor(Math.random() * UPPERCASE.length)],
    DIGITS[Math.floor(Math.random() * DIGITS.length)],
    SYMBOLS[Math.floor(Math.random() * SYMBOLS.length)],
  ]
  for (let i = chars.length; i < GENERATED_LENGTH; i++) {
    chars.push(ALL_CHARS[Math.floor(Math.random() * ALL_CHARS.length)])
  }
  for (let i = chars.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[chars[i], chars[j]] = [chars[j], chars[i]]
  }
  return chars.join("")
}

type PasswordRule = {
  label: string
  test(password: string): boolean
}

const PASSWORD_RULES: PasswordRule[] = [
  {
    label: `At least ${MIN_LENGTH} characters`,
    test: (p) => p.length >= MIN_LENGTH,
  },
  { label: "Contains uppercase letter", test: (p) => /[A-Z]/.test(p) },
  { label: "Contains lowercase letter", test: (p) => /[a-z]/.test(p) },
  { label: "Contains number", test: (p) => /\d/.test(p) },
  { label: "Contains special character", test: (p) => /[^\dA-Za-z]/.test(p) },
]

const MIN_CATEGORIES_MET = 4

export function getPasswordValidity(password: string) {
  const results = PASSWORD_RULES.map((rule) => ({
    label: rule.label,
    passed: rule.test(password),
  }))
  const lengthPassed = results[0].passed
  const categoriesMet = results.slice(1).filter((r) => r.passed).length
  const isValid = lengthPassed && categoriesMet >= MIN_CATEGORIES_MET - 1
  return { results, isValid }
}
